export function onSelectPoints(index, setPointsSteps) {
  setPointsSteps(prev => prev.map((step, stepIndex) => ({ ...step, selected: index === stepIndex })));
}

export function onConfirmRedemption(
  pointsSteps,
  setPointsToRedeem,
  setAmountToRedeem,
  setShowSnackBar,
  setPaymentOptions
) {
  const pointsSelected = pointsSteps?.length > 0 ? pointsSteps.find(point => point.selected) : null;
  setPointsToRedeem(pointsSelected?.points ?? 0);
  if (pointsSelected?.points > 0) {
    setPaymentOptions(prev => [
      ...prev.filter(val => val.type !== 'POINTS_REDEMPTION'),
      { type: 'POINTS_REDEMPTION', value: pointsSelected?.points ?? 0 },
    ]);
  } else {
    setPaymentOptions(prev => [...prev.filter(val => val.type !== 'POINTS_REDEMPTION')]);
  }
  const discount = pointsSelected?.discountAmount ?? 0;
  setAmountToRedeem(discount);
  if (discount > 0) setShowSnackBar(true);
}

export function onClearRedemption(setPointsSteps) {
  setPointsSteps(prev => prev.map(step => ({ ...step, selected: false })));
}

export default { onSelectPoints, onConfirmRedemption, onClearRedemption };
